export default __webpack_public_path__ + "static/media/tip8.e2c81f21.png";